import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es difícil de seguir?',
    a: 'No, el protocolo central solo requiere 15 minutos al despertar.'
  }, {
    q: '¿Debo dejar los carbohidratos?',
    a: 'No, aprenderás a comerlos en el orden correcto para que te den energía en lugar de quitártela.'
  }, {
    q: '¿Necesito equipo especial?',
    a: 'Solo luz solar, agua y comida real.'
  }, {
    q: '¿Funciona si tengo problemas de tiroides?',
    a: 'Este protocolo apoya la salud metabólica general, lo cual es beneficioso para cualquier condición hormonal, siempre bajo supervisión médica.'
  }, {
    q: '¿Puedo seguir tomando café?',
    a: 'Sí, pero te enseñaremos el momento exacto para que trabaje a tu favor y no en tu contra.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-[#132118] border-y border-white/5" data-id="element-26">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-29">
            Preguntas frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-30">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#162019] border border-white/5 rounded-xl overflow-hidden" data-id="element-31">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-32">
                <span className="text-lg font-medium text-white" data-id="element-33">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-emerald-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-34" />
              </button>

              <AnimatePresence data-id="element-35">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-36">
                    <div className="px-6 pb-6 text-gray-400 leading-relaxed" data-id="element-37">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}